import React from 'react'
import { connect } from 'react-redux'
import '../../assets/styles/components/instrument/instrument-profile.scss'
import { dataType } from '../../constants/data-type';
import DataTable from '../DataTable/DataTable';
import { stockActions } from '../../actions/trading/stock.action';
import { ACTION_TYPE } from "../../constants/w-socket";
import { WS_LANG_KEY } from '../../constants/app';
import { utilsFunction, Converter } from "../../helpers/functions";
import { getSafe } from '@/helpers/global';
import LoadingLayer from '../Spinner/LoadingLayer';
import classnames from 'classnames';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env';

class InstrumentProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      unFold: false,
      marketID: '',
      InstrumentID: '',
      load: false,
      companyInfoData: {},
      dividendColDef: [
        {
          headerName: props.language.common_type,
          colId: 'common_type',
          field: 'type',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT
        },
        {
          headerName: props.language.common_content,
          colId: 'common_content',
          field: 'content',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT
        },
        {
          headerName: props.language.common_clear_date,
          colId: 'common_clear_date',
          field: 'clearDate',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.SHORT_DATE
        },
        {
          headerName: props.language.common_dividend_date,
          colId: 'common_dividend_date',
          field: 'dividendDate',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.SHORT_DATE
        }
      ],
      shareholderColDef: [
        {
          headerName: props.language.common_name,
          colId: 'common_name',
          field: 'name',
          headerClass: 'table-header',
          cellClass: 'table-cell cell-action',
          dataType: dataType.TEXT
        },
        {
          headerName: props.language.common_shares_held,
          colId: 'common_shares_held',
          field: 'holdNum',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.NUMBER
        },
        {
          headerName: props.language.common_hold_rate,
          colId: 'common_hold_rate',
          field: 'holdRate',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.NUMBER
        }
      ],
      dividendData: null,
      shareholderData: null,
      foldTips: false
    }
    this.unfoldRef = React.createRef();
    this.foldRef = React.createRef();
  }

  getCompanyInfos() {
    let stockID = this.state.InstrumentID.split('').findIndex(i => i !== '0')
    if (stockID > -1) {
      stockID = this.state.InstrumentID.substr(stockID)
    }
    const params = {
      msgType: ACTION_TYPE.SECURITY_COMPANY_INFO,
      symbol: { exchangeID: Converter.mappingWebSocketMarket(this.state.marketID), key: stockID },
      language: utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
    }
    this.setState({
      load: true
    })
    this.props.getCompanyInfo(params, res => {
      if (res) {
        this.setState({
          companyInfoData: res,
          load: false,
          foldTips: true
        // }, () => {
        //   this.unfoldRef.current.width = this.foldRef.current.offsetWidth
        //   if (this.unfoldRef.current.offsetHeight > this.foldRef.current.offsetHeight) {
            // this.setState({
            //   foldTips: true
            // })
          // } else {
          //   this.setState({
          //     foldTips: false
          //   })
          // }
        })
      }
    })
  }

  getShareChanges() {
    let stockID = this.state.InstrumentID.split('').findIndex(i => i !== '0')
    if (stockID > -1) {
      stockID = this.state.InstrumentID.substr(stockID)
    }
    const params = {
      msgType: ACTION_TYPE.SECURITY_SHARE_CHANGE,
      symbol: { exchangeID: Converter.mappingWebSocketMarket(this.state.marketID), key: stockID },
      language: utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
    }
    this.shareholderRef.toggleLoadingOverlay(true);
    this.props.getShareChange(params, res => {
      if (res.shareChange) {
        let shareData = []
        let header = res.shareChange.header
        let data = res.shareChange.data
        for (var i = 0; i < data.length; i++) {
          let arr = {}
          for (var j = 0; j < header.length; j++) {
            arr = Object.assign(arr, { [header[j]]: (data[i])[j] })
          }
          shareData.push(arr)
        }
        this.setState({
          shareholderData: shareData
        })
      } else {
        this.setState({
          shareholderData: []
        })
      }
    })
    this.shareholderRef.toggleLoadingOverlay(false);
  }

  getDividendRecords() {
    let stockID = this.state.InstrumentID.split('').findIndex(i => i !== '0')
    if (stockID > -1) {
      stockID = this.state.InstrumentID.substr(stockID)
    }
    const params = {
      msgType: ACTION_TYPE.SECURITY_DIVIDEND_RECORD,
      symbol: { exchangeID: Converter.mappingWebSocketMarket(this.state.marketID), key: stockID },
      language: utilsFunction.switchToolTipsLanguage(this.props.language, WS_LANG_KEY.EN, WS_LANG_KEY.SC, WS_LANG_KEY.TC)
    }
    this.dividendRef.toggleLoadingOverlay(true);
    this.props.getDividendRecord(params, res => {
      if (res.dividendRecord) {
        let dividenData = []
        let header = res.dividendRecord.header
        let data = res.dividendRecord.data
        for (var i = 0; i < data.length; i++) {
          let arr = {}
          for (var j = 0; j < header.length; j++) {
            arr = Object.assign(arr, { [header[j]]: (data[i])[j] })
          }
          dividenData.push(arr)
        }
        this.setState({
          dividendData: dividenData
        })
      } else {
        this.setState({
          dividendData: []
        })
      }
    })
    this.dividendRef.toggleLoadingOverlay(false);
  }

  componentDidMount() {
    const { marketParams } = this.props;
    const { marketID, stockCode } = marketParams;
    this.setState({
      marketID: marketID,
      InstrumentID: stockCode
    }, () => {
      this.getCompanyInfos()
      // this.getShareChanges()
      this.getDividendRecords()
    })
    // this.unfoldRef.current.width = this.foldRef.current.offsetWidth
    // if (this.unfoldRef.current.offsetHeight > this.foldRef.current.offsetHeight) {
      this.setState({
        foldTips: true
      })
    // } else {
    //   this.setState({
    //     foldTips: false
    //   })
    // }
  }

  componentDidUpdate(prevProps, prevState) {
    const { marketParams } = this.props;
    const { marketID, stockCode } = marketParams;
    if (prevProps.marketParams && marketParams !== prevProps.marketParams) {
      if (marketID === 'HK' || marketID === 'MA' || marketID === 'SZ' || marketID === 'US') {
        this.setState({
          marketID: Converter.mappingMDSMarketToStock(marketID),
          InstrumentID: utilsFunction.instrumentIDZeroPadding(stockCode)
        }, () => {
          this.getCompanyInfos()
          // this.getShareChanges()
          this.getDividendRecords()
        })
      } else {
        this.setState({
          marketID: marketID,
          InstrumentID: stockCode
        }, () => {
          this.getCompanyInfos()
          // this.getShareChanges()
          this.getDividendRecords()
        })
      }
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return
    }
  }

  render() {
    const { language, autoSize } = this.props;
    const { unFold, dividendColDef, dividendData, shareholderColDef, shareholderData, companyInfoData, load, foldTips } = this.state;
    return (
      <div className={classnames("instrument-profile-container", `instrument-profile-container-${iTradeEnv.company}`)}>
        <section className='instrument-profile-info'>
          <LoadingLayer load={load} />
          <header>{getSafe(() => language.common_Profile)}</header>
          <div className="infor-item">
            <label>{getSafe(() => language.common_companyName)}</label>
            <span>{companyInfoData ? (companyInfoData.basicInfo ? (companyInfoData.basicInfo.companyName ? companyInfoData.basicInfo.companyName : '-') : '-') : '-'}</span>
          </div>
          <div className="infor-item">
            <label>{getSafe(() => language.common_chairman)}</label>
            <span>{companyInfoData ? (companyInfoData.basicInfo ? (companyInfoData.basicInfo.chairperson ? companyInfoData.basicInfo.chairperson : '-') : '-') : '-'}</span>
          </div>
          <div className="infor-item">
            <label>{getSafe(() => language.common_listingDate)}</label>
            <span>{companyInfoData ? (companyInfoData.basicInfo ? (companyInfoData.basicInfo.listingDate ? companyInfoData.basicInfo.listingDate : '-') : '-') : '-'}</span>
          </div>
          <div className="infor-item">
            <label>{getSafe(() => language.common_initialPrice)}</label>
            <span>{companyInfoData ? (companyInfoData.basicInfo ? (companyInfoData.basicInfo.issuePrice ? companyInfoData.basicInfo.issuePrice : '-') : '-') : '-'}</span>
          </div>
          <div className="infor-item">
            <label>{getSafe(() => language.common_totalCapital)}</label>
            <span>{companyInfoData.totalCapital ? utilsFunction.currencyFormatter(companyInfoData.totalCapital) : '-'}</span>
          </div>
          <div className="infor-item" >
            <label>{getSafe(() => language.common_business)}</label>
            <span ref={this.foldRef} className={unFold ? "" : "overflow-text"}>
              {companyInfoData ? (companyInfoData.basicInfo ? (companyInfoData.basicInfo.business ? companyInfoData.basicInfo.business : '-') : '-') : '-'}
            </span>
            {
              foldTips &&
              <div className='unfold-action' onClick={() => this.setState({ unFold: !this.state.unFold })}>
                {unFold ? getSafe(() => language.market_fold) : getSafe(() => language.market_unfold)}
              </div>
            }
          </div>
          {/* <div className="sp-item">
            <label>{getSafe(() => language.common_business)}</label>
            <span ref={this.unfoldRef}>{companyInfoData ? (companyInfoData.basicInfo ? (companyInfoData.basicInfo.business ? companyInfoData.basicInfo.business : '-') : '-') : '-'}</span>
          </div> */}

        </section>
        <section style={{ height: 400 }}>
          <header>{getSafe(() => language.common_dividend_payout)}</header>
          <DataTable
            showPagination={false}
            columnDefs={dividendColDef}
            autoSizeColumns={autoSize}
            innerRef={e => this.dividendRef = e}
            data={dividendData} />
        </section>
        {/* <section style={{ height: 300 }}>
          <header>{getSafe(() => language.common_shareholder_holding)}</header>
          <DataTable
            showPagination={false}
            columnDefs={shareholderColDef}
            innerRef={e => this.shareholderRef = e}
            autoSizeColumns={autoSize}
            data={shareholderData} />
        </section> */}
      </div>
    )
  }
}

InstrumentProfile.defaultProps = {
  isFilter: false,
  autoSize: true
}

export default connect(
  state => ({
    language: state.app.language,
    marketParams: state.trade.marketParams
  }),
  dispatch => ({
    getCompanyInfo: (p, c) => stockActions.getCompanyInfoAction(p, c),
    getShareChange: (p, c) => stockActions.getShareChangeAction(p, c),
    getDividendRecord: (p, c) => stockActions.getDividendRecordAction(p, c)
  })
)(InstrumentProfile)
